import React from 'react';
import { Bot } from 'lucide-react';
import { Card } from '../../../components/ui/card';
import { fmtNum } from './kpiUtils';
import { fmtPct } from './atencionUtils';
import { ColumnasSelector, useColumnas } from './ColumnasSelector';
import { TablaAtencion } from './TablaAtencion';

const COLUMNAS = [
  { key: 'motivo', label: 'Motivo', fija: true, className: 'text-slate-700' },
  { key: 'submotivo', label: 'Submotivo', className: 'text-slate-500' },
  { key: 'cantidad', label: 'Cantidad', right: true, render: (f) => fmtNum(f.cantidad) },
  { key: 'resueltos', label: 'Resueltos por el bot', right: true, defecto: false, render: (f) => fmtNum(f.resueltos) },
  { key: 'pct_resuelto', label: '% resuelto por el bot', right: true, render: (f) => fmtPct(f.pct_resuelto) },
];

const Barra = ({ label, n, total, color, testId }) => (
  <div data-testid={testId}>
    <div className="mb-1 flex justify-between text-sm"><span className="text-slate-600">{label}</span><span className="font-semibold tabular-nums">{fmtNum(n)}</span></div>
    <div className="h-2.5 overflow-hidden rounded-full bg-slate-100">
      <div className="h-full rounded-full transition-[width] duration-500" style={{ width: `${total ? (n / total) * 100 : 0}%`, backgroundColor: color }} />
    </div>
  </div>
);

// B4: bot de WhatsApp — resueltos vs derivados y motivo x submotivo.
export const AtencionBot = ({ bot = {} }) => {
  const cols = useColumnas('bot', COLUMNAS);
  return (
    <Card className="mb-6 p-5 lg:p-6" data-testid="atencion-bot">
      <div className="mb-4 flex items-center gap-2">
        <h2 className="flex items-center gap-2 text-base font-semibold text-slate-800"><Bot className="h-4 w-4 text-green-600" /> Bot de WhatsApp</h2>
        <div className="ml-auto"><ColumnasSelector columnas={COLUMNAS} estado={cols} testId="atencion-bot-cols" /></div>
      </div>
      <div className="grid gap-6 lg:grid-cols-3">
        <div className="space-y-4">
          <p className="text-3xl font-bold text-green-700" data-testid="atencion-bot-tasa">{fmtPct(bot.tasa_pct)}</p>
          <p className="-mt-3 text-xs text-slate-500">resueltos por el bot sobre {fmtNum(bot.total)} tickets</p>
          <Barra label="Resueltos por el bot" n={bot.resueltos} total={bot.total} color="#16a34a" testId="atencion-bot-resueltos" />
          <Barra label="Derivados a soporte" n={bot.derivados} total={bot.total} color="#f59e0b" testId="atencion-bot-derivados" />
          {bot.sin_dato > 0 && <Barra label="Sin dato en el asunto" n={bot.sin_dato} total={bot.total} color="#94a3b8" testId="atencion-bot-sin-dato" />}
        </div>
        <div className="lg:col-span-2">
          <TablaAtencion columnas={COLUMNAS} ver={cols.ver} filas={bot.tabla || []} rowKey={(f) => `${f.motivo}-${f.submotivo}`}
            rowTestId={(f, i) => `atencion-bot-fila-${i}`} vacio="Sin tickets del bot en el período." sticky maxH="max-h-[340px]" />
        </div>
      </div>
    </Card>
  );
};
